import * as EmailValidator from 'email-validator';

export default function isValidEmail(email: string): boolean {
  return EmailValidator.validate(email);
}

export function isValidEmailDomain(domain: string): boolean {
  return isValidEmail(`test@${domain}`);
}
